var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('VueMarkdown',{staticClass:"md",staticStyle:{"text-align":"center","margin":"20px"},attrs:{"loading":"lazy","source":_vm.team.toString()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }